'use strict';

require('magnific-popup');

const $ = require('jquery');
const appConfig = window.AppConfig;
const locale = appConfig.locale.substr(0, 2);

function init() {
    const menuLink = $('.js-menu-subscribe-link');

    menuLink.on('click', ev => {
        ev.preventDefault();
        openModal();
        return false;
    });
}

function openModal(url, email) {
    $.magnificPopup.open({
        items: [
            {
                src: email ?
                    `${url}?email=${encodeURIComponent(email)}` :
                    url,
                type: 'iframe',
            }
        ],
        callbacks: {
           markupParse: function(template, values, item) {
               template.addClass('mfp-iframe-scaler--white');
           }
        }
    });
}

module.exports = {
    init,
    openModal,
};



// WEBPACK FOOTER //
// ./modules/newsSignupModal.js